import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider, useApp } from "@/context/AppContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import Nav from "@/components/Nav";
import Dashboard from "@/pages/Dashboard";
import Beneficiaries from "@/pages/Beneficiaries";
import Resources from "@/pages/Resources";
import Submission from "@/pages/Submission";
import Login from "@/pages/Login";
import BeneficiaryDetail from "@/pages/BeneficiaryDetail";
import AdminSettings from "@/pages/AdminSettings";
import Impact from "@/pages/Impact";
import NotFound from "@/pages/NotFound";
import { Toaster } from "sonner";

function Footer() {
  const { settings } = useApp();
  return (
    <footer className="border-t border-[color:var(--ink)]/20 py-6 text-center text-xs text-[#141414]/60 px-4">
      {settings?.footer_text || "Built with care · Bersama untuk Flores 7.7"}
    </footer>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <div className="App min-h-screen">
        <AppProvider>
          <BrowserRouter>
            <Nav />
            <main className="pb-16">
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/beneficiaries" element={<Beneficiaries />} />
                <Route path="/w/:id" element={<BeneficiaryDetail />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/submit" element={<Submission />} />
                <Route path="/login" element={<Login />} />
                <Route path="/admin" element={<AdminSettings />} />
                <Route path="/impact" element={<Impact />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </BrowserRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              style: { border: "1.5px solid #141414", borderRadius: 12, background: "#fff", color: "#141414", fontFamily: "Space Grotesk" },
            }}
          />
        </AppProvider>
      </div>
    </ErrorBoundary>
  );
}

export default App;
